module.exports = __webpack_public_path__ + "static/media/companyProfilenewchange.6bc8fbfd.png";